<template>
  <FontAwesomeIcon
    :icon="['fal', 'check-square']"
    class="mt-2 mr-1 text-blue-900"
  />
  {{ translatedLabel }}
</template>
<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'LabelWitchCheckBoxChecked',
  components: { FontAwesomeIcon },
  props: {
    element: {},
    translatable: {},
    translationExtention: {}
  },
  computed: {
    translatedLabel() {
      if (this.translatable) {
        return this.$t(`${this.translationExtention}.${this.element.name}`)
      } else {
        return this.element.name
      }
    }
  }
}
</script>
